<div class="modal-container">
    <div class="modal-container-body">
        <div class="design-container">
            <!-- Left bloc -->
            <div class="design-left-box">
                <!-- select available promotions container -->
                <div class="design-left-box-selection">
                    <!-- Customization header -->
                    <div class="design-left-box-header">
                        <!-- [@animateHeader]="hasItemSelected ? 'out' : 'in'" -->
                        <div class="design-left-box-header-content">
                            <div class="design-left-box-header-back" (click)="ref.close()">
                                <div class="icon-smash_back back-icon"></div>
                                <div>{{ 'UPLOADER_PROMOTION_MODAL_RECEIVER_BUTTON_LABEL_BACK' | translate }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- error message -->
                    <div class="design-left-box-error" *ngIf="hasError">
                        {{ 'PREMIUM_PROMOTION_ERROR_MESSAGE' | translate }}
                    </div>
                    <div class="design-left-box-text-content">
                        <!-- Page de téléchargement -->
                        <h1>{{ 'UPLOADER_PROMOTION_MODAL_RECEIVER_TITLE' | translate }}</h1>
                        <!-- Personnalisez le contenu qui sera diffusé pendant le téléchargement de vos fichiers par vos destinataires.  -->
                        <p>{{ 'UPLOADER_PROMOTION_MODAL_RECEIVER_TEXT' | translate }}</p>
                    </div>
                    <!-- Add your content button show for freemium-->
                    <button *ngIf="(isFreemium$ | async)" (click)="onAddPromotion()">
                        <!-- Insérer votre contenu -->
                        {{ 'UPLOADER_PROMOTION_MODAL_INSERT_YOUR_CONTENT' | translate }}
                    </button>
                    <!-- Available list items container -->
                    <div class="design-left-box-list-container" *ngIf="!!(selectedPromotion$ | async)">
                        <ng-scrollbar>
                            <!-- content List -->
                            <ul class="design-left-box-list-content">
                                <!-- Select content item -->
                                <li *ngFor="let content of promotions$ | async" class="design-left-box-list-content-item"
                                    (click)="onSelectPromotion(content)">
                                    <div>
                                        <input type="checkbox" disabled name="selectedPromotion" value="{{content.id}}"
                                            [checked]="selected && content.id === selected.id">
                                        <label>
                                            {{content.title}}
                                            <div *ngIf="selected && content.id === selected.id" class="replay-icon" (click)="onReplay($event)">
                                                <span class="icon-smash_player "></span>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="design-left-box-list-content-item-icon" *ngIf="isSelected(content)">
                                        <i class="icons8-replay"></i>
                                    </div>
                                </li>
                            </ul>
                        </ng-scrollbar>
                    </div>
                </div>
            </div>
            <!-- Right Bloc -->
            <div class="design-right-box">
                <div class="design-right-box-content">
                    <ng-container *ngIf="!!(selectedPromotion$ | async); else promotionLoading">
                        <app-smash-promotion class="design-right-box-preview-container"
                            [inputIndexSelected]="selectedMedia? selectedMedia.index : null" [replay]="replay"
                            [promotion]="selectedPromotion$ | async" componentSource="modal-promotion">
                        </app-smash-promotion>
                    </ng-container>
                    <ng-template #promotionLoading>
                        <div class="loading-spinner-container">
                            <div class="loading-spinner-grey"></div>
                        </div>
                    </ng-template>
                </div>
                <div class="overlay" *ngIf="isLoading">
                    <div class="spinner-update">
                        <div class="loading-spinner-grey"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>